<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="newCollections"
      :options.sync="pagination"
      :server-items-length="totalNewCollections"
      :loading="loading"
      :footer-props="{
        'showFirstLastPage':true,
        'items-per-page-options': [10, 20, 50, 100]
      }"
      class="elevation-1"
    >
      <template v-slot:item.start="{ item }">
        {{ parseDate(item.start) }}
      </template>
      <template v-slot:item.end="{ item }">
        {{ parseDate(item.end) }}
      </template>
      <template v-slot:item.shops="{ item }">
        {{ item.shops.length > 0 ? item.shops[0].name : "" }}
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on }">
            <v-icon v-if="item.shops.length > 1" small class="mr-2" v-on="on"
            >mdi-dots-horizontal
            </v-icon>
          </template>
          <v-list dense style="max-height: 500px" class="overflow-y-auto">
            <v-list-item v-for="(item, i) in item.shops" :key="i">
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>

      <template v-slot:item.categories="{ item }">
        {{ item.categories.length > 0 ? item.categories[0].name : "" }}
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on }">
            <v-icon v-if="item.categories.length > 1" small class="mr-2" v-on="on"
            >mdi-dots-horizontal
            </v-icon>
          </template>
          <v-list dense style="max-height: 500px" class="overflow-y-auto">
            <v-list-item v-for="(item, i) in item.categories" :key="i">
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>

      <template v-slot:item.cities="{ item }">
        {{ item.cities.length > 0 ? item.cities[0].name : "" }}
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on }">
            <v-icon v-if="item.cities.length > 1" small class="mr-2" v-on="on"
            >mdi-dots-horizontal
            </v-icon>
          </template>
          <v-list dense style="max-height: 500px" class="overflow-y-auto">
            <v-list-item v-for="(item, i) in item.cities" :key="i">
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>

      <template v-slot:item.allCities="{ item }">
        <v-switch v-model="item.allCities" disabled></v-switch>
      </template>
      <template v-slot:item.clear="{ item }">
        <v-avatar v-if="currentUser.superAdmin || (!currentUser.superAdmin && !item.allCities)" color="teal" size="26" rounded>
          <router-link
            :to="{
              name: 'NewCollectionEdit',
              params: { newCollectionId: item.id }
            }"
          >
            <v-icon dark>mdi-pencil</v-icon>
          </router-link>
        </v-avatar>
      </template>
      <template v-slot:item.add="{ item }">
        <v-avatar v-if="currentUser.superAdmin || (!currentUser.superAdmin && !item.allCities)" color="red darken-4" size="26" rounded>
          <v-icon dark @click="delRecord(item)">mdi-delete</v-icon>
        </v-avatar>
      </template>
      <template v-slot:body.prepend>
        <tr>
          <td>
            <v-spacer></v-spacer>
          </td>
          <td>
            <v-spacer></v-spacer>
          </td>
          <td>
            <v-spacer></v-spacer>
          </td>
          <td>
            <v-spacer></v-spacer>
          </td>
          <td>
            <v-spacer></v-spacer>
          </td>
          <td>
            <v-spacer></v-spacer>
          </td>
          <td>
            <v-spacer></v-spacer>
          </td>
          <td>
            <v-spacer></v-spacer>
          </td>
          <td>
            <v-avatar color="indigo" size="30">
              <v-icon
                dark
                @click="
                  page = 1;
                  retrieveNewCollections();
                "
                >mdi-magnify
              </v-icon>
            </v-avatar>
          </td>
          <td>
            <router-link :to="{ name: 'NewCollectionCreate' }">
              <v-avatar color="teal" size="26" rounded>
                <v-icon dark>mdi-plus</v-icon>
              </v-avatar>
            </router-link>
          </td>
        </tr>
      </template>
    </v-data-table>
    <ConfirmDialog ref="confirm" />
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ConfirmDialog from "@/view/pages/ConfirmDialog";
import {mapGetters} from "vuex";
import moment from "moment";

export default {
  name: "newCollections",
  computed: {
    ...mapGetters(["currentUser"]),
    headers(){
      return [
      { text: "Id", align: "start", sortable: false, value: "id" },
      { text: this.$i18n.t('date.from'), value: "start", sortable: false },
      { text: this.$i18n.t('date.to'), value: "end", sortable: false },
      { text: this.$i18n.t('pages.recommendedCategories.allCities'), value: "allCities", sortable: false },
      { text: this.$i18n.t('commonTable.cities'), value: "cities", sortable: false },
      { text: this.$i18n.t('commonTable.shops'), value: "shops", sortable: false },
      { text: this.$i18n.t('commonTable.categories'), value: "categories", sortable: false },
      { text: "", value: "search", width: "5%" },
      { text: "", value: "clear", width: "5%" },
      { text: "", value: "add", width: "5%" }
    ]}
  },
  data() {
    return {
      totalNewCollections: 0,
      newCollections: [],
      newCollection: {
        start: "",
        end: "",
        allCities: true,
        cityIds: [],
        shopIds: [],
        categoryIds: []
      },
      loading: true,
      pagination: {},
      dialogDelete: false,
      itemToDelete: null,
      errors: []
    };
  },
  watch: {
    pagination: {
      handler() {
        this.retrieveNewCollections();
      },
      deep: true
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "New Collections" }]);
  },
  components: {
    ConfirmDialog
  },
  methods: {
    parseDate(date) {
      return moment
          .utc ( date )
          .local ()
          .format ( "yyyy-MM-DD HH:mm:ss" );
    },
    async delRecord(item) {
      if (
        await this.$refs.confirm.open(
          this.$i18n.t('common.confirm'),
          this.$i18n.t('pages.newCollection.deleteMessage') +
            item.id +
            " ?"
        )
      ) {
        this.deleteRecord(item);
      }
    },
    deleteRecord(item) {
      this.deleteNewCollection(item.id);
    },
    deleteNewCollection(newCollectionId) {
      this.loading = true;
      ApiService.delete(`api/new-collection/${newCollectionId}`)
        .then(response => {
          this.$log.debug("New collection deleted: ", response);
          this.retrieveNewCollections();
        })
        .catch(error => {
          this.$log.error("Error: ", error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    getRequestParams() {
      let params = {};

      let sort;
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      if (sortBy.length === 1 && sortDesc.length === 1) {
        sort = sortBy[0];
        if (sortDesc[0] === true) sort += ",desc";
      }
      params["sort"] = sort;
      params["page"] = this.pagination.page;
      params["size"] = this.pagination.itemsPerPage;

      return params;
    },

    retrieveNewCollections() {
      const params = this.getRequestParams();
      return new Promise(resolve => {
        this.loading = true;
        ApiService.query("api/new-collection", {
          params
        }).then(response => {
          // JSON responses are automatically parsed.
          this.$log.debug("New collections: ", response.data.content);
          this.newCollections = response.data.content;
          this.totalNewCollections = response.data.totalElements;
          this.totalPages = response.data.totalPages;
          this.loading = false;
          let title =
            this.totalNewCollections != null ? this.totalNewCollections : 0;
          this.$store.dispatch(SET_BREADCRUMB, [
            { title: "New Collections: " + title }
          ]);
          resolve();
        });
      });
    }
  }
};
</script>

<style>
.v-data-table.v-data-table.v-data-table >>> td {
  font-size: 16px;
}

.v-icon.v-icon {
  font-size: 24px !important;
}

tbody tr:nth-of-type(even) {
  background-color: rgba(236, 237, 237);
}

tbody tr:nth-of-type(odd) {
  background-color: rgb(250, 250, 250);
}
</style>
